export class SpriteFrameData {
    constructor(id, type, imgfileref, xmlfileref, spritesheetId) {
        this.sprId = id;
        this.type = type;
        this.imgfileref = imgfileref;
        this.xmlfileref = xmlfileref;
        this.selected = false;
        this.spritesheetId = spritesheetId; // index into the spritesheet cache
        this.animationPrefix = '';
        this.rect = {
            x: 0,
            y: 0,
            width: null,
            height: null
        };
        this.transform = {
            newWidth: null,
            newHeight: null,
            flipX: false,
            flipY: false
        };
        this.frameRect = {
            frameX: 0,
            frameY: 0,
            frameWidth: null,
            frameHeight: null
        };
        this._changed = false;
    }
    clone() {
        const clonedFrame = new SpriteFrameData(this.sprId, this.type, this.imgfileref, this.xmlfileref, this.spritesheetId);
        clonedFrame.selected = this.selected;
        clonedFrame.animationPrefix = this.animationPrefix;
        clonedFrame.rect = Object.assign({}, this.rect);
        clonedFrame.transform = Object.assign({}, this.transform);
        clonedFrame.frameRect = Object.assign({}, this.frameRect);
        return clonedFrame;
    }
}
